<template>
  <div class="grey lighten-4 text-right pa-4">
    <span class="mx-4">Tổng tiền thu/đóng</span>
    <span v-if="!loadingFeeMoney" class="red--text mx-4"
      >{{ totalFeeMoney ? totalFeeMoney.toLocaleString('en-US') : 0 }} VNĐ</span
    >
    <span class="mr-2 detail_text" @click="setToggleFilter" v-if="!loadingFeeMoney"
      ><router-link to="/financial-report" class="text-decoration-none font-weight-bold">
        Xem chi tiết
      </router-link></span
    >
  </div>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex'
export default {
  computed: {
    ...mapGetters({
      totalFeeMoney: 'tuitionFeePeriod/totalFeeMoney',
      loadingFeeMoney: 'tuitionFeePeriod/loadingFeeMoney',
      toggleFilter: 'tuitionFeeReport/toggleFilter',
      detailPeriod: 'tuitionFeePeriod/detailPeriod'
    })
  },
  methods: {
    ...mapMutations('tuitionFeeReport', ['setToggleFilter'])
  }
}
</script>
<style lang="scss">
.detail_text {
  font-size: 14px;
  color: #0d47a1;
}
</style>
